import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { PlaylistsProvider } from "@/context/PlaylistsContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Albums from "@/pages/Albums";
import Videos from "@/pages/Videos";
import VideoGroup from "@/pages/VideoGroup";
import VideoWatch from "@/pages/VideoWatch";
import AlbumDetail from "@/pages/AlbumDetail";
import { Artists, ArtistDetail } from "@/pages/Artists";
import { Songs, Favorites } from "@/pages/Songs";
import { Playlists, PlaylistDetail } from "@/pages/Playlists";
import Builder from "@/pages/Builder";
import Upload from "@/pages/Upload";
import Wishlist from "@/pages/Wishlist";

import Radio from "@/pages/Radio";
import Audiobooks from "@/pages/Audiobooks";
import AudiobookDetail from "@/pages/AudiobookDetail";
import Settings from "@/pages/Settings";
import SharedPlaylist from "@/pages/SharedPlaylist";
import MissingArt from "@/pages/MissingArt";
import Offline from "@/pages/Offline";
import Duplicates from "@/pages/Duplicates";
import Privacy from "@/pages/Privacy";
import ResetPassword from "@/pages/ResetPassword";

function Protected() {
  const { user } = useAuth();
  if (user === null) return <div className="flex h-screen items-center justify-center bg-[#FAF9F6]"><Loader2 className="animate-spin text-zinc-400" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <PlaylistsProvider>
      <PlayerProvider>
        <Layout />
      </PlayerProvider>
    </PlaylistsProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/reset" element={<ResetPassword />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Navigate to="/albums?sort=recent" replace />} />
            <Route path="/albums" element={<Albums />} />
            <Route path="/album/:id" element={<AlbumDetail />} />
            <Route path="/missing-art" element={<MissingArt />} />
            <Route path="/offline" element={<Offline />} />
            <Route path="/duplicates" element={<Duplicates />} />
            <Route path="/artists" element={<Artists />} />
            <Route path="/artist" element={<ArtistDetail />} />
            <Route path="/songs" element={<Songs />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/playlists" element={<Playlists />} />
            <Route path="/playlists/:id" element={<PlaylistDetail />} />
            <Route path="/builder" element={<Builder />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/stats" element={<Navigate to="/settings?page=stats" replace />} />
            <Route path="/radio" element={<Radio />} />
            <Route path="/audiobooks" element={<Audiobooks />} />
            <Route path="/audiobooks/:id" element={<AudiobookDetail />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/videos/group/:key" element={<VideoGroup />} />
            <Route path="/videos/watch/:id" element={<VideoWatch />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/admin" element={<Navigate to="/settings" replace />} />
            <Route path="/shared/:id" element={<SharedPlaylist />} />
            <Route path="*" element={<Navigate to="/albums?sort=recent" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" offset={110} />
    </AuthProvider>
  );
}

export default App;
